<app-spinner></app-spinner>

<div mat-flat-button class="formclose" align="right" (click)="closesubcategoryForm()"><img
        src="assets/img/icons/forma-11.png"> </div>
<div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
    <div class="loginbox">

        <form [formGroup]="Subcategory" class="example-form">
            <div class="fheader">Add Sub-Category</div>

            <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                <div class="flabel">Name</div>
                <mat-form-field appearance="outline" class="example-full-width" style="width:100%">
                    <input (keypress)="handleInput($event)" placeholder="Enter Name" matInput formControlName="name" value="">
                </mat-form-field>
                <mat-error *ngIf="validator.UniqueSubcategory">{{validator.errorMessage}}</mat-error>
            </div>

            <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                <div class="col-sm-6 col-xs-6 col-md-6 col-lg-6" style="padding: 15px">Drag on logo here</div>
                <div class="col-sm-3 col-xs-3 col-md-3 col-lg-3" style="padding: 0px;width:70px;height:70px;
margin-top: 10px;">
                    <input type="file" style="display: none" (change)="onfileselected($event)" #fileInput> <span
                        class="Rounded-Rectangle-1" mat-button (click)="fileInput.click()"> <span><img
                                *ngIf="!logoPreview" style="text-align: center;
width:60%;height:70%" src="assets/img/icons/UploadBlue.png">
                            <img *ngIf="logoPreview" style="text-align: center;
width:100%;height:100%" [src]="logoPreview" />
                        </span></span>



                </div>
            </div>

            <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                <button style="width:100%" [disabled]="!Subcategory.valid" mat-flat-button class="btn"
                    (click)="createtemplate()">Add</button>
            </div>
        </form>

    </div>
</div>